export default {
  DEFAULT_SITE_NAME: 'untitled',
  BUSINESS_HOURS: 'businessHours',
  BUSINESS_LOGO: 'businessLogo',
  SOCIAL_LINKS: 'socialLinks',
  EMAILS: 'emails',
  DEFAULT_SITE_PROGRESS_CHECKLIST: {
    createSite: true,
    setYourSiteTitle: false,
    addYourLogo: false,
    setYourHeadline: false,
    addLeadingImages: false,
    customizeBlocks: false,
    pickYourFonts: false,
    chooseYourColorPalette: false,
    enableWebsiteAnimations: false,
    connectYourSocialProfiles: false,
    addYourPhoneNumber: false,
    addAndDeleteBlocks: false,
    customizeYourButtons: false,
    customizeYourFooterBlock: false,
    enableACookieBanner: false,
    addContactsPage: false,
    addMorePages: false,
    finalizeWebsiteNavigation: false,
    removeTheBrandedFooter: false,
    addShopBlock: false,
    configureYourOnlineStore: false,
    publishYourWebsite: false,
    shareYourSiteInSocialNetworks: false,
    verifyYourSiteInGoogleSearchConsole: false,
    optimizeForSearch: false,
    addCustomDomain: false,
    addPersonalizedEmailAddress: false,
  },
};
